import { render, staticRenderFns } from "./ItemAutocomplete.vue?vue&type=template&id=184587b2&scoped=true"
import script from "./ItemAutocomplete.vue?vue&type=script&lang=js"
export * from "./ItemAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184587b2",
  null
  
)

export default component.exports